




































































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import {
  IWorkflowsInputCreateStatus,
  IWorkflowsInputModifyJobsJob,
  IWorkflowsInputModifyStatusesStatus,
} from '@/api/types/request.types'
import { EEntities } from '@/types'
import TextAssistant from '@/helpers/text-assistant'

/* API */

export default Vue.extend({
  name: 'WorkflowStatusItem',

  props: {
    index: {
      type: Number,
      default: -1,
    },
    status: {
      type: Object as () =>
        | IWorkflowsInputCreateStatus
        | IWorkflowsInputModifyStatusesStatus,
      required: true,
    },
    showDelete: {
      type: Boolean,
      default: false,
    },
    showDrag: {
      type: Boolean,
      default: false,
    },
    showSettings: {
      type: Boolean,
      default: false,
    },
    /* Jobs related */
    selectedJobId: {
      type: Number,
      default: null,
    },
    /* Jobs related */
    jobs: {
      type: Array as () => IWorkflowsInputModifyJobsJob[],
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    isSample: {
      type: Boolean,
      default: false,
    },
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
    focusOnCreate: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      ColorAssistant,
      TextAssistant,
    }
  },

  computed: {
    activeLabel(): string {
      return this.status.isInactive ? 'Inactive' : 'Active'
    },
    allowJobsManagement(): boolean {
      return (
        this.$permissions.jobsFeatureEnabled &&
        this.jobs !== null &&
        this.jobs.length > 0
      )
    },
  },

  created() {
    if (this.focusOnCreate) {
      this.$nextTick(() => {
        // @ts-ignore
        this.$refs.nameInput.focus()
      })
    }
  },

  methods: {
    showMoreIcon(
      status: IWorkflowsInputCreateStatus | IWorkflowsInputModifyStatusesStatus,
    ): boolean {
      return this.showStatusTransitionsIcon(status) && this.showDelete
    },
    showStatusTransitionsIcon(
      status: IWorkflowsInputCreateStatus | IWorkflowsInputModifyStatusesStatus,
    ): boolean {
      // @ts-ignore
      return this.showSettings && !this.readOnly && status.id
    },
    toggleActiveState() {
      this.status.isInactive = !this.status.isInactive
    },
    handleDeleteClick(index: number) {
      if (!this.showDelete) {
        return
      }
      this.$emit('delete-clicked', index)
    },
  },
})
